import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { ButtonFooterDiscardAll } from '@cart-ui/ButtonFooterDiscardAll/ButtonFooterDiscardAll'
import { sendFastpassRemoveFromCartEvent } from '@dni-analysis'
import { generateItemVariant } from '@dni-analysis/events/utils'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useCart } from '../CartProvider/CartProvider'
import { MerchantSelector } from './MerchantSelector'

export interface CartHeaderProps {
  defaultDraftName?: string
  showDraftName?: boolean
}
export const CartHeader = (_props: CartHeaderProps) => {
  const { currency, campaignCodeFromUrl, campaignId, platform } = useCart()
  const { resetCartValues, items: cartItems } = useFpB2bCartService(campaignId, platform)
  /**
   * .TODO: 與pm確認，之後aicart相關會再調整，目前暫不處理
   *  const { defaultDraftName, showDraftName } = props
   * const { setDraftName } = useFpB2bButlerService(campaignId, Platform.MERCHANT)
   * const handleDraftNameChange: InputProps['onChange'] = (event) => {
    setDraftName(event.target.value)
  }
  */

  const handleDiscardAllConfirm = () => {
    if (campaignCodeFromUrl) {
      sendFastpassRemoveFromCartEvent({
        currency,
        campaign_code: campaignCodeFromUrl,
        value: cartItems.reduce((acc, item) => acc + item.sale_price * item.quantity, 0),
        items: cartItems.map(item => ({
          currency,
          item_id: String(item.cartItemId),
          item_name: item.name,
          price: item.sale_price,
          quantity: item.quantity,
          item_brand: item.project_code,
          item_variant: generateItemVariant({
            productName: item.name,
            attributes: item.attributes,
          }),
        })),
      })
    }
    resetCartValues({ excludes: ['butler'] })
  }
  return (
    <Box display="flex" alignItems="center" maxWidth={950} p={1}>
      {/** TODO: 與pm確認，之後aicart相關會再調整，目前暫不處理 */}
      {/* {
        showDraftName && (
          <HStack gap={2} alignItems='center'>
            <Text>採購單名稱</Text>
            <Input defaultValue={defaultDraftName} onChange={handleDraftNameChange} placeholder="請輸入" />
          </HStack>
        )
      } */}
      <HStack justifyContent="space-between" alignItems="center" width="100%">
        <HStack gap={1}>
          <VStack justifyContent="center">
            <Text>經銷商</Text>
          </VStack>
          <MerchantSelector />
        </HStack>
        <ButtonFooterDiscardAll onDialogConfirm={handleDiscardAllConfirm} />
      </HStack>
    </Box>
  )
}
